import { render, staticRenderFns } from "./icon-commission.vue?vue&type=template&id=6e44c7e8"
import script from "./icon-commission.vue?vue&type=script&lang=js"
export * from "./icon-commission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports